import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'
import { useSubmit } from './FormMixin'
import { accountDeleteResource } from '@/services/profile.service'
import useGlobal from '@/composables/useGlobal'
import { useSuccessToast } from '@/composables/useToast'
import { useConfirmDialog } from '@/composables/useConfirm'
import { logo_main } from '@/const'
import useField from '@/composables/useField'

const phoneMask = "+38 (0##) ### ## ##"


export default /*@__PURE__*/_defineComponent({
  __name: 'AccountDeleteForm',
  setup(__props, { expose: __expose }) {
  __expose();

const load = ref(false)
const { $t } = useGlobal()
const password = ref('')
const phone = ref('')
const fullName = ref('')
const reason = ref('')
const textField = useField(
  'reason',
  $t('Reason for deletion'),
  {
    component: 'd-control-textarea',
    class: 'is-textarea is-textarea--full_h',
    rows: 8,
    rules: 'min:5|max:255|required',
  }
)

const request = (sendData, control) => {
  useSubmit(
    send(sendData, control),
    control
  )
}

const clearForm = (resetForm) => {
  resetForm()
  phone.value = ''
  password.value = ''
  fullName.value = ''
  reason.value = ''
}
const send = async (sendData:any, control:any) => {
  const question = $t('Are you sure you want to delete your account?')
  const successMessage = $t('Your request has been sent successfully.')
  try {
    await useConfirmDialog({
      question
    })
    load.value = true
    const preparedData = {
      ...sendData,
      phone: sendData.phone.replace(/\D/g, '')
    }
    await accountDeleteResource.execute(
      {},
      preparedData
    )
    clearForm(control.resetForm)
    useSuccessToast(successMessage)
    load.value = false
  } catch(e) {
    load.value = false
    return Promise.reject(e)
  }
}


const __returned__ = { load, $t, password, phone, fullName, reason, phoneMask, textField, request, clearForm, send, ref, get useSubmit() { return useSubmit }, get accountDeleteResource() { return accountDeleteResource }, get useGlobal() { return useGlobal }, get useSuccessToast() { return useSuccessToast }, get useConfirmDialog() { return useConfirmDialog }, get logo_main() { return logo_main }, get useField() { return useField } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})